module.exports = __webpack_public_path__ + "img/template1.bde3380e.svg";